/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";

//************************* Libreria para realizar pdfs *************************/
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { PDFDocument } from "pdf-lib";

// ------------------ COMPONENTES DE BASE--------------------------------
import { formatNumberDecimal } from "../../../../../Base/Services/FormatTemplate";
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import { getLocalDateString } from "../../../../../Base/Services/FechasService";
import { getDateString } from "../../../../../Base/Services/Moment/Luxon";

// ------------------- CONSULTAS A LA API--------------------------------
import { DatosCompletos } from "../../../../../API/Compras/Ordenes/OrdenesComprasRequests";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import { OrdenesComprasReporteLang } from "./OrdenesComprasLang";

import QRCode from "qrcode";
import { getInformacionEmpresa } from "../../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { RequisasComprasReporteLang } from "../../Requisas/Reporte/RequisasComprasLang"; 
import { getFirmaPersonal } from "../../../../../API/Payrolls/Firmas/FirmasRequests";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const OrdenesComprasReporte1 = ({
  showReporte,
  setShowReporte,
  selectedDetalle,
  Language,
  setLanguaje
}) => {
  const [loading, setLoading] = useState(true);
  const [pdfRequisa, setPdfRequisa] = useState([]);
  const [pdfOrden, setPdfOrden] = useState([]);
  const [pdfUrlCombinado, setPdfUrlCombinado] = useState(null);
  const toast = useRef(null);

  const obtenerInformacion = async () => {
    try {

      setLoading(true);
      if (!selectedDetalle || selectedDetalle.length === 0) {
        return;
      }

      const infoEmpresaTempo = await getInformacionEmpresa();
      let name = infoEmpresaTempo[0]?.NombreLegal;
      let direccion = infoEmpresaTempo[0]?.Direccion;
      let RTNEmpresa = infoEmpresaTempo[0]?.RTN;
      let logoB64 = infoEmpresaTempo[0]?.LogoPrimarioB64;
      let telefono = infoEmpresaTempo[0]?.Telefono;

      const IdPurchaseOrder = [
        ...new Set(
          selectedDetalle
            .map((item) => item.IdPurchaseOrder)
            .filter((id) => id !== undefined && id !== null)
        ),
      ].join(",");

      if (!IdPurchaseOrder) {
        return;
      }

      const resp = await DatosCompletos(IdPurchaseOrder);

      if (!resp) {
        return;
      }

      if (resp.length === 0) {
        return;
      }

      await GenerarReporteOrdenes(
        resp,
        name,
        direccion,
        RTNEmpresa,
        logoB64,
        telefono
      );

    } catch (error) {
      console.error("ERROR EN obtenerInformacion:", error);
    } finally {
      setLoading(false);
    }
  };
 
  const calcularCantidadTotal = (listadoDetalles) => {
    let cantidadTot = 0;
    listadoDetalles.forEach((detalle) => {
      cantidadTot += detalle.Quantity;
    });
    return cantidadTot;
  };

  const calcularCantidadProductos = (listadoDetalles) => {
    const idProductsSet = new Set();
    listadoDetalles.forEach((detalle) => {
      idProductsSet.add(detalle?.IdComponent);
    });


    return idProductsSet.size;
  };

  const obtenerImagenPDF = (img) => {
    if (!img || typeof img !== "string") return null;

    const limpia = img.trim();

    if (!limpia) return null;

    if (limpia.startsWith("data:image/")) {
      return limpia;
    }

    return `data:image/png;base64,${limpia}`;
  };

  const GenerarReporteOrdenes = async (Datos, name, direccion, RTNEmpresa, logoB64, telefono) => {
    const pdfReq = [];
    const pdfOr = [];
    const requisasGeneradas = new Set()
    const logoPDF = obtenerImagenPDF(logoB64);

    for (const [key, value] of Object.entries(Datos)) {
      let data = value;
      let listadoDetalles = data?.ListadoDetalles
      
      const cantidadTot = calcularCantidadTotal(listadoDetalles);
      const cantidadProductos = calcularCantidadProductos(listadoDetalles);

      
      const monedas = [
        ...new Set(listadoDetalles.map((detalle) => detalle.CurrencySymbol)),
      ];


      let CodigoQR 
      QRCode.toDataURL( `${data.PurchaseOrder}`, { errorCorrectionLevel: "Q" }, (err, url) => {CodigoQR = url});

      // DISEÑO DE REPORTE ORDEN COMPRAS
      const docDefinitionOrden = {
        pageSize: "LETTER",
        pageOrientation: "portrait",
        pageMargins: [35, 85, 30, 95],

        header: function (currentPage, pageCount, pageSize) {
          return [
            {
              columns: [
                logoPDF
                ? {
                    image: logoPDF,
                    width: 200,
                    margin: [4, -10, -10, -10],
                  }
                : {
                    text: "",
                    width: 200,
                    margin: [4, -10, -10, -10],
                  },
  
                [
                  {
                    text: name,
                    style: "titulo2",
                    margin: [-10, 30, 0, 0],
                    width: 350,
                  },
                  {
                    text: direccion,
                    style: "titulo",
                    margin: [-10, 5, 0, 0],
                    width: 350,
                  },
                ],
                [
                  {
                    text: `${getLabel(
                      OrdenesComprasReporteLang,
                      "TituloReporte",
                      Language
                    )} \n ${data?.PurchaseOrder || ""}`,
                    style: "numeroDoc",
                    width: 100,
                    margin: [0, 35, 0, 0],
                  },
                ],
              ],
            },
          ];
        },
  
        footer: (currentPage, pageCount) => {
          return {
            table: {
              widths: [450, 150],
              body: [
                [
                  {
                    text:
                      `TEST`
                      + "\n\n" +
                      `${getLabel(
                        OrdenesComprasReporteLang,
                        "fecha",
                        Language
                      )}` + getLocalDateString(new Date())
                      + "\n\n" +
                      `${getLabel(
                        OrdenesComprasReporteLang,
                        "original",
                        Language
                      )}`
                      + "\n\n" +
                      `${getLabel(
                        OrdenesComprasReporteLang,
                        "copia",
                        Language
                      )}\n\n` +
                      `${getLabel(
                        OrdenesComprasReporteLang,
                        "textFinal",
                        Language
                      )}\n\n`
                    ,
                    margin: [30, -20, 5, 0],
                    fontSize: 7.5,
                  },
                  {
                    image: CodigoQR,
                    width: 70,
                    margin: [0, -15, 30, 0],
                    alignment: "right",
                  },
                ],
                [
                  {
                    image: CodigoQR,
                    width: 70,
                    margin: [0, -15, 30, 0],
                    alignment: "right",
                  },

                  {
                    text: `${getLabel(
                      OrdenesComprasReporteLang,
                      "Pagina",
                      Language
                    )} ${currentPage} / ${pageCount}`,
                    margin: [30, -20, -20, 0],
                    fontSize: 7.5,
                  },
                ],
              
              ],
            },
            layout: {
              fillColor: function (rowIndex, node, columnIndex) {
                return rowIndex % 2 === 0 ? "#FFFFFF" : null;
              },
              defaultBorder: false,
            }
          };
        },

        content: [
          {
            columns: [
              {
                margin: [0, 0, 0, 0],
  
                table: {
                  widths: [400, '*'],
                  body: [
                    [
                      {
                        text: `${getLabel(OrdenesComprasReporteLang,"fecha",Language)} ${getDateString(new Date())}`,
                        border: [false, false, false, false],
                        style: "infoGeneral",
                      },
                      {
                        text: `RTN: ${RTNEmpresa}`,
                        border: [false, false, false, false],
                        style: "infoGeneralRTN",
                      },
                    ],
                  ],
                },
              },
            ],
          },
          {
            columns: [
              {
                margin: [0, 0, 0, 10],
  
                table: {
                  widths: [532],
                  body: [
                    [
                      {
                        text: ``,
                        style: "infoGeneral",
                        border: [false, false, false, true],
                      },
                    ],
                  ],
                },
              },
            ],
          },
          {
            table: {
              margin: [0, 15, 0, 10],
              widths: [263, 263],
              body: [
                [
                  { text: `${getLabel(OrdenesComprasReporteLang,"proveedor",Language)}`, style: "subtitle", border: [true, true, true, false] },
                  { text: `${getLabel(OrdenesComprasReporteLang,"envioA",Language)}`, style: "subtitle", border: [false, true, true, false]  },
                ],
              ],
            },
            layout: {
              hLineWidth: function (i) {
                return 0.05; // Establecer grosor de línea horizontal
              },
              vLineWidth: function (i) {
                return 0.05; // Establecer grosor de línea vertical
              },
              hLineColor: function (i) {
                return "#aaa"; // Color de las líneas horizontales
              },
              vLineColor: function (i) {
                return "#aaa"; // Color de las líneas verticales
              },
            },
          },
          {
            table: {
              margin: [0, 15, 0, 10],
              widths: [40,215, 40,215],
              body: [
                [
                  { text: `${getLabel(OrdenesComprasReporteLang,"nombre",Language)}`, style: "subtitle2", border: [true, false, false, false] }, 
                  { text: `${data?.Expr1 || ""}`, style: "infoProveedor", border: [false, false, false, false] }, 
                  { text: `${getLabel(OrdenesComprasReporteLang,"nombre",Language)}`, style: "subtitle2", border: [true, false, false, false] },
                  { text: `${name || ''}`, style: "infoProveedor", border: [false, false, true, false] }
                ],
                [
                  { text: `Attn: `, style: "subtitle2", border: [true, false, false, false] }, 
                  { text: ``, style: "infoProveedor", border: [false, false, false, false] }, 
                  { text: `Attn:`, style: "subtitle2", border: [true, false, false, false] },
                  { text: `${data?.UserNameAgente ||''}`, style: "infoProveedor", border: [false, false, true, false] }
                ],
                [
                  { text: `${getLabel(OrdenesComprasReporteLang,"direccion",Language)}`, style: "subtitle2",border: [true, false, false, false] }, 
                  { text: `${data?.DireccionVendor ||''}`, style: "infoProveedor", border: [false, false, false, false] }, 
                  { text: `${getLabel(OrdenesComprasReporteLang,"direccion",Language)}`,style: "subtitle2", border: [true, false, false, false] },
                  { text: `${direccion || ""}`, style: "infoProveedor", border: [false, false, true, false] }
                ],
                [
                  { text: `${getLabel(OrdenesComprasReporteLang,"telefono",Language)} `, style: "subtitle2",border: [true, false, false, true] }, 
                  { text: ` ${data?.Telefono || ""}`, style: "infoProveedor", border: [false, false, false, true] }, 
                  { text: `${getLabel(OrdenesComprasReporteLang,"telefono",Language)}`, style: "subtitle2", border: [true, false, false, true] },
                  { text: `${telefono ||""}`, style: "infoProveedor", border: [false, false, true, true] }
                ],
              ],
            },
            layout: {
              hLineWidth: function (i) {
                return 0.05; // Establecer grosor de línea horizontal
              },
              vLineWidth: function (i) {
                return 0.05; // Establecer grosor de línea vertical
              },
              hLineColor: function (i) {
                return "#aaa"; // Color de las líneas horizontales
              },
              vLineColor: function (i) {
                return "#aaa"; // Color de las líneas verticales
              },
            },
          },
          {
            margin: [0, 20, 5, 5],
            table: {
              widths: [25, 24, 35, 98, 100, 32, 32, 32, 37],
            
              body: [
                [
                  { text: `${getLabel(OrdenesComprasReporteLang,"cantidad",Language)}`, style: "header" },
                  { text: `${getLabel(OrdenesComprasReporteLang,"unidad",Language)}`, style: "header" },
                  { text: `${getLabel(OrdenesComprasReporteLang,"codigo",Language)}`, style: "header" },
                  { text: `${getLabel(OrdenesComprasReporteLang,"producto",Language)}`, style: "header" },
                  { text: `${getLabel(OrdenesComprasReporteLang,"descripcion",Language)}`, style: "header" },
                  { text: `${getLabel(OrdenesComprasReporteLang,"precio",Language)}`, style: "header" },
                  { text: `${getLabel(OrdenesComprasReporteLang,"isv",Language)}`, style: "header" },
                  { text: `${getLabel(OrdenesComprasReporteLang,"descuento",Language)}`, style: "header" },
                  { text: `SUBTOTAL`, style: "header" },
                ],
                ...listadoDetalles.map(d =>
                  [
                    { text: formatNumberDecimal(`${d.Quantity || ""}`), style: 'textBody1' },
                    { text: `${d.UnitSimbol || ""}`, style: 'textBody1' },
                    { text: `${d.CodigoProducto || ""}`, style: 'textBody1' },              
                    { text: `${d.NombreProducto || ""}`, style: 'textBody3' },              
                    { text: `${d.Description || ""}`, style: 'textBody3' },
                    { text: formatNumberDecimal(`${d.UnitPrice || ""}`), style: 'textBody2' },
                    { text: formatNumberDecimal(`${d?.TAX + d?.ISV18 || ""}`), style: 'textBody2' },
                    { text: formatNumberDecimal(`${d.Discount || ""}`), style: 'textBody2' },
                    { text: formatNumberDecimal(`${d.SubTotal || ""}`), style: 'textBody2' },
                  ],
                )          
              ],
            },
            layout: 'lightHorizontalLines'
          },
  
  
          {
            margin: [3, 3, 5, 5],
            table: {
              widths: [30, 25, 90, 147, 35, 35, 35, 70],
              body: [
                [
                  {
                    text: formatNumberDecimal(`${cantidadTot}`),
                    style: "headerr",
                    border: [false, true, false, false],
                  },
                  {
                    text: ``,
                    style: "header",
                    border: [false, true, false, false],
                  },
                  {
                    text: formatNumberDecimal(`${cantidadProductos}`),
                    style: "headerr",
                    border: [false, true, false, false],
                    margin:[10,0,0,0]
                  },
                  {
                    text: ``,
                    style: "header",
                    border: [false, true, false, false],
                  },
                  {
                    text: ``,
                    style: "header",
                    border: [false, true, false, false],
                  },
                  {
                    text: ``,
                    style: "header",
                    border: [false, true, false, false],
                  },
                  {
                    text: ``,
                    style: "header",
                    border: [false, true, false, false],
                  },
                  {
                    text: ``,
                    style: "header",
                    border: [false, true, false, false],
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function (i) {
                return 0.05; // Establecer grosor de línea horizontal
              },
  
              hLineColor: function (i) {
                return "#aaa"; // Color de las líneas horizontales
              },
            },
          },
  
  
  
  
          
          {
            margin: [0, 10, 5, 10],
            table: {
              widths: [390, 50, 15,60],
              body:
                [
                    [
                      { text: ``, style: 'textCentrado', border: [false, false, false, false], width:[340] },
                      { text: 'SubTotal', style: 'textTotales' },
                      {text:`${monedas}`,border: [false, true, false, true],style: 'textTotales' },
                      { text: formatNumberDecimal(`${data?.SubTotal || ''}`), border: [false, true, true, true],style: 'textTotales'  },
                    ],
                    [
                      { text: ``, rowSpan: 2, border: [false, false, false, false], style: 'textCentrado',width:[340] },
                      { text: `${getLabel(OrdenesComprasReporteLang,"desc",Language)}`, style: 'textTotales' },
                      {text: `${monedas}`,border: [false, true, false, true],style: 'textTotales' },
                      { text: formatNumberDecimal(`${data?.Discount || ""}`), style: 'textTotales',border: [false, true, true, true] },
                    ],
                    [
                      { text: '',style: 'textCentrado', border: [false, false, false, false]},
                      { text: `${getLabel(OrdenesComprasReporteLang,"isv",Language)}`, style: 'textTotales' },
                      {text:`${monedas}`,border: [false, true, false, true],style: 'textTotales'},
                      { text: formatNumberDecimal(`${data?.TAX + data?.ISV18 || ""}`), style: 'textTotales',border: [false, true, true, true] },
                    ],
                    [
                      { text: '',style: 'textCentrado', border: [false, false, false, false]},
                      { text: `${getLabel(OrdenesComprasReporteLang,"fletes",Language)}`, style: 'textTotales' },
                      {text:`${monedas}`,border: [false, true, false, true],style: 'textTotales'},
                      { text: formatNumberDecimal(`${data?.Freights  || ""}`), style: 'textTotales',border: [false, true, true, true] },
                    ],
                    [
                      { text: '',style: 'textCentrado', border: [false, false, false, false] },
                      { text: `${getLabel(OrdenesComprasReporteLang,"otros",Language)}`, style: 'textTotales' },
                      {text:`${monedas}`,border: [false, true, false, true],style: 'textTotales'},
                      { text: formatNumberDecimal(`${data?.Otros  || ""}`), style: 'textTotales',border: [false, true, true, true] },
                    ],
                    [
                      { text: '',style: 'textCentrado', border: [false, false, false, false] },
                      { text: 'Total', style: 'textTotales' },
                      {text:`${monedas}`,border: [false, true, false, true],style: 'textTotales'},
                      { text: formatNumberDecimal(`${data?.Total || ""}`), style: 'textTotales',border: [false, true, true, true] },
                    ], 
                ]
            },
            layout: {
              hLineWidth: function (i) {
                return 0.05; // Establecer grosor de línea horizontal
              },
              vLineWidth: function (i) {
                return 0.05; // Establecer grosor de línea vertical
              },
              hLineColor: function (i) {
                return "#aaa"; // Color de las líneas horizontales
              },
              vLineColor: function (i) {
                return "#aaa"; // Color de las líneas verticales
              },
            },
          },
          {
            margin: [0, 10, 5, 5,5],
            table: {
              widths: [390, 50,50],
              body:
                [
  
                  [
                    { text: `${getLabel(OrdenesComprasReporteLang,"terminosPago",Language)} ${data?.TerminoPago || ""}`, style: 'textBody3', border: [false, false, false, false], width:[340] },
                  ],
                  [
                    { text: `${getLabel(OrdenesComprasReporteLang,"terminosInco",Language)}  ${data?.TerminoInco || ""}`, border: [false, false, false, false], style: 'textBody3',width:[340] },
                  ],
                  [
                    { text: `${getLabel(OrdenesComprasReporteLang,"comentario",Language)}  ${data?.Description || ""}`, border: [false, false, false, false], style: 'textBody3',width:[340] },
                  ],
                ]
            },
          },
          {
            columns: [
              {
                  margin: [0, 100, 0, 0],
      
                  table: {
                      widths: [150, 20, 150, 20, 150],
                      body: [
                          [
                              { text: '', border: [false, false, false, false] },
                              { text: '', border: [false, false, false, false] },
                              { text: '', border: [false, false, false, true] },
                              { text: '', border: [false, false, false, false] },
                              { text: '', border: [false, false, false, false] },
                          ],
                          [
                              {
                                border: [false, false, false, false],
                                text: '', width: [120]
                              },
                              {
                                  border: [false, false, false, false],
                                  text: '', width: [100]
                              },
                              {
                                  border: [false, true, false, false],
                                  text: `${getLabel(OrdenesComprasReporteLang,"deptoCompras",Language)}`,
                                  style: 'firmas', width: [120]
                              },
                              {
                                border: [false, false, false, false],
                                text: '', width: [120]
                              },
                              {
                                border: [false, false, false, false],
                                text: '', width: [120]
                              },
                          ]
      
                      ]
                  }
              }
          ]
          },
  
        ],

        styles: {
          tableExample: {
            margin: [0, 5, 0, 15],
          },
          titulo: {
            fontSize: 8,
            bold: true,
            alignment: "justify",
          },
          titulo2: {
            fontSize: 9,
            bold: true,
            alignment: "justify",
          },
          requisa: {
            fontSize: 15,
            bold: true,
            alignment: "justify",
          },
          numeroDoc: {
            fontSize: 12,
            bold: true,
            alignment: "center",
          },
          subtitle: {
            fontSize: 8,
            bold: true,
            alignment: "center",
          },
          subtitle2: {
            fontSize: 8,
            bold: true,
          },
          infoGeneral: {
            fontSize: 8,
            margin: [-5, 0, 0, 0],
          },
          infoGeneralRTN: {
            fontSize: 8,
            margin: [-5, 0, 0, 0],
            alignment: 'right'
          },
          infoProveedor: {
            fontSize: 8,
            margin: [0, 0, 0, 0],
          },
          header: {
            fontSize: 6.5,
            alignment: "center",
            bold: true,
          },
          headerr: {
            fontSize: 7,
            margin: [-5, 0, 0, 0],
          },
          textBody1: {
            fontSize: 7.5,
            alignment: "center",
          },
          textBody2: {
            fontSize: 7.5,
            alignment: "right",
          },
          textBody3: {
            fontSize: 7.5,
            alignment: "justify",
          },
          textBody4: {
            fontSize: 8.5,
            alignment: "justify",
          },
          textTotales: {
            bold: true,
            fontSize: 7.5,
            alignment: "right",
          },
          textCentrado: {
            fontSize: 7.5,
            alignment: "center",
          },
          firmas: {
            fontSize: 8,
            bold: true,
            alignment: "center",
            lineHeight: 1,
          },
          footer: {
            fontSize: 7.5,
            alignment: "left",
            margin: [30, 0, 5, 0],
          },
        },
      };

      const docOrden = pdfMake.createPdf(docDefinitionOrden);
      await new Promise((resolve) => {
        docOrden.getDataUrl((url) => {
          pdfOr.push(url);
          resolve();
        });
      });


      if (data?.RequisasAg && data?.RequisasAg.length > 0) {
        for (let requisa of data.RequisasAg) {

          if (!requisasGeneradas.has(requisa?.Requisa?.IdPurchaseRequest)) {
              requisasGeneradas.add(requisa?.Requisa?.IdPurchaseRequest); 
          
              let Encabezado = requisa?.Requisa
              let Detalles = requisa?.DetallesRequisa

              const UserNameAutorizoGerente = Detalles[0]?.UserNameAutorizoGerente ?? "";
              const UserNameautorizoPlantManager = Detalles[0]?.UserNameAutorizoPlantManager ?? "";
              // const UserNameAutorizoFinanzas = Detalles[0]?.UserNameAutorizoFinanzas ?? "";

              let Texturl
              QRCode.toDataURL(`${Encabezado.PurchaseRequest}`, { errorCorrectionLevel: 'Q' }, (err, url) => {
                Texturl = url;
              })
              
              // DISEÑO DEL ENCABEZADO REPORTE REQUISA COMPRAS
              const docDefinitionRequisa = {
                pageSize: "LETTER",
                pageOrientation: "portrait",
                pageMargins: [35, 85, 30, 95],

                  header: function (currentPage, pageCount, pageSize) {
                      return [
                      {
                          widths: [200, 350, 20],
                          columns: [
                          [
                            logoPDF
                              ? {
                                  image: logoPDF,
                                  width: 200,
                                  margin: [4, -10, -10, -10],
                                }
                              : {
                                  text: "",
                                  width: 200,
                                  margin: [4, -10, -10, -10],
                                },
                            {},
                          ],
                          [
                              {
                              text: name,
                              style: "titulo2",
                              margin: [-10, 30, 0, 0],
                              width: 320,
                              },
                              {
                              text: direccion,
                              style: "titulo3",
                              margin: [-10, 5, 0, 0],
                              width: 320,
                              fillColor: "#FF0000",
                              },
  
  
                          ],
                          [
                              {
                              text: `${getLabel(
                                  RequisasComprasReporteLang,
                                  "TituloReporte",
                                  Language
                              )}\n ${Encabezado?.PurchaseRequest || ""} `,
                              style: "numeroDoc",
                              margin: [0, 40, 0, 0],
                              },
                          ]
                          ],
                      },
                      ];
                  },

                  footer: (currentPage, pageCount) => {
                    return {
                      table: {
                        widths: [450, 150],
                        body: [
                          [
                            {
                              text:
                                `${getLabel(
                                  RequisasComprasReporteLang,
                                  "fechaImpresion",
                                  Language
                                )}` +
                                getLocalDateString(new Date()) +
                                "\n\n" +
                                `${getLabel(
                                  RequisasComprasReporteLang,
                                  "original",
                                  Language
                                )}` +
                                "\n\n" +
                                `${getLabel(
                                  RequisasComprasReporteLang,
                                  "copia",
                                  Language
                                )}\n\n`,
                              margin: [30, -20, 5, 0],
                              fontSize: 7.5,
                            },
                            {
                              image: Texturl,
                              width: 70,
                              margin: [0, -15, 30, 0],
                              alignment: "right",
                            },
                          ],
                          //NUMERO DE PAGUINA Y QR
                          [
                            {
                              image: Texturl,
                              width: 70,
                              margin: [0, -15, 30, 0],
                              alignment: "right",
                            },
                            
                            {
                              text: `${getLabel(
                                RequisasComprasReporteLang,
                                "Pagina",
                                Language
                              )} ${currentPage} / ${pageCount}`,
                              margin: [0, 8, 35, 0],
                              fontSize: 7.5,
                              alignment: "right",
                            },
                          ],
                        ],
                      },
                      layout: {
                        defaultBorder: false,
                      },
                    };
                  },

                  content: [
                      {
                        columns: [
                          {
                            margin: [0, 0, 0, 0],
              
                            table: {
                              widths: [250, 20, 250],
                              body: [
                                [
                                  {
                                    text: `${getLabel( RequisasComprasReporteLang, "fechaCreacion", Language )} ${getDateString(new Date(Encabezado?.DateCreated || ""))}`,
                                    border: [false, false, false, false],
                                    style: "infoGeneral",
                                  },
                                  { text: "", border: [false, false, false, false] },
                                  { text: ``, border: [false, false, false, false] },
                                ],
                                [
                                  {
                                    text: `${getLabel(RequisasComprasReporteLang,"area",Language)} ${Encabezado?.Area || ""}`,
                                    border: [false, false, false, false],
                                    style: "infoGeneral",
                                  },
                                  { text: "", border: [false, false, false, false] },
                                  {
                                    text: `${getLabel(RequisasComprasReporteLang,"creadoPor",Language)} ${Encabezado?.UserName || ""}`,
                                    border: [false, false, false, false],
                                    style: "infoGeneral",
                                    alignment: "right",
                                  },
                                ],
                                [
                                  {
                                    text: `${getLabel(RequisasComprasReporteLang,"tipo",Language)} ${Encabezado?.Type || ""}`,
                                    border: [false, false, false, true],
                                    style: "infoGeneral",
                                  },
                                  { text: "", border: [false, false, false, true] },
                                  {
                                    text: `${getLabel(RequisasComprasReporteLang,"solicitadoPor",Language)} ${Encabezado?.UserRequest || ""} `,
                                    border: [false, false, false, true],
                                    style: "infoGeneral",
                                    alignment: "right",
                                  },
                                ],
                              ],
                            },
                          },
                        ],
                      },
                  ],
  
                  styles: {
                      tableExample: {
                        margin: [0, 5, 0, 15],
                      },
                      titulo: {
                        fontSize: 8,
                        // margin: [0, 50, 0, 0],
                        bold: true,
                        alignment: "justify",
                      },
                      titulo2: {
                        fontSize: 10,
                        // margin: [0, 50, 0, 0],
                        bold: true,
                        alignment: "justify",
                      },
                      titulo3: {
                        fontSize: 10,
                        // margin: [0, 50, 0, 0],
                        // bold: true,
                        alignment: "justify",
                      },
                      requisa: {
                        fontSize: 15,
                        // margin: [0, 50, 0, 0],
                        bold: true,
                        alignment: "justify",
                      },
                      numeroDoc: {
                        fontSize: 10,
                        bold: true,
                        alignment: "center",
                      },
                      infoGeneral: {
                        fontSize: 8,
                        margin: [-5, 0, 0, 0],
                        // bold: true,
                        // alignment: 'justify'
                      },
                      infoProveedor: {
                        fontSize: 8,
                        margin: [0, 0, 0, 0],
                      },
                      header: {
                        fontSize: 6.5,
                        alignment: "center",
                        bold: true,
                      },
                      headerr: {
                        fontSize: 7,
                        alignment: "center",
                        // bold: true,
                      },
                      textBody1: {
                        fontSize: 7.5,
                        alignment: "center",
                        // lineHeight: 2
                      },
                      textBody2: {
                        fontSize: 7,
                        alignment: "right",
                        // lineHeight: 2
                      },
                      textBody3: {
                        fontSize: 7.5,
                        alignment: "justify",
                        // lineHeight: 2
                      },
                      textBody4: {
                        fontSize: 8.5,
                        alignment: "justify",
                        // lineHeight: 2
                      },
                      textTotales: {
                        bold: true,
                        fontSize: 7.5,
                        alignment: "right",
                      },
                      textCentrado: {
                        fontSize: 7.5,
                        alignment: "center",
                      },
                      firmas: {
                        fontSize: 8,
                        bold: true,
                        alignment: "center",
                        lineHeight: 1,
                      },
                      footer: {
                        fontSize: 7.5,
                        alignment: "left",
                        margin: [30, 0, 5, 0],
                      },
                  },
              };

              
              const detallesPorMoneda = {};
              Detalles.forEach((detalle) => {
                const moneda = detalle.CurrencySymbol || detalle.Currency;
                if (!detallesPorMoneda[moneda]) {
                  detallesPorMoneda[moneda] = [];
                }
                detallesPorMoneda[moneda].push(detalle);
              });

              Object.entries(detallesPorMoneda).forEach(([moneda, detalles]) => {
                const productosMoneda = detalles.map((d) => {
                  return [
                    { text: d.CodigoProducto, style: "textBody1" },
                    { text: d.NombreProducto, style: "textBody3" },
                    { text: formatNumberDecimal(d.Quantity), style: "textBody1" },
                    { text: d.UnitName, style: "textBody1" },
                    { text: formatNumberDecimal(d.Price), style: "textBody2" },
                    { text: formatNumberDecimal(d.TAX + d?.ISV18), style: "textBody2" },
                    { text: formatNumberDecimal(d.Discount), style: "textBody2" },
                    { text: formatNumberDecimal(d.SubTotal), style: "textBody2" },
                    { text: formatNumberDecimal(d.Total), style: "textBody2" },
                  ];
                });
          
                let numberOfRows = 0;
                numberOfRows += productosMoneda.length;
          
                let numberOfProduct = detalles.reduce(
                  (total, detalle) => total + detalle.Quantity,
                  0
                );
          
                const subtotalMoneda = detalles.reduce(
                  (total, detalle) => total + detalle.SubTotal,
                  0
                );
                const descuentoMoneda = detalles.reduce(
                  (total, detalle) => total + detalle.Discount,
                  0
                );
                const impuestoMoneda = detalles.reduce(
                  (total, detalle) => total + detalle.TAX,
                  0
                );
                const impuesto18Moneda = detalles.reduce(
                  (total, detalle) => total + detalle.ISV18,
                  0
                );
                const totalMoneda = detalles.reduce(
                  (total, detalle) => total + detalle.Total,
                  0
                );
            
                docDefinitionRequisa.content.push(
                  {
                    margin: [0, 8, 0, 0],
                    text:
                      `${getLabel(RequisasComprasReporteLang, "detallesEn", Language)}` +
                      `${detalles[0].Currency}`,
                    style: "titulo",
                  },
                  {
                    margin: [0, 10, 5, 5],
                    table: {
                      widths: [45, 142, 32, 30, 32, 32, 32, 32, 40],
                      body: [
                        [
                          {
                            text: `${getLabel(RequisasComprasReporteLang,"codigo",Language )}`,
                            style: "header",
                          },
                          {
                            text: `${getLabel(RequisasComprasReporteLang, "producto",Language)}`,
                            style: "header",
                          },
                          {
                            text: `${getLabel(RequisasComprasReporteLang,"cantidad",Language)}`,
                            style: "header",
                          },
                          {
                            text: `${getLabel(RequisasComprasReporteLang,"unidad",Language )}`,
                            style: "header",
                          },
                          {
                            text: `${getLabel(RequisasComprasReporteLang,"precio",Language)}`,
                            style: "header",
                          },
                          {
                            text: `${getLabel(RequisasComprasReporteLang,"isv",Language)}`,
                            style: "header",
                          },
                          {
                            text: `${getLabel(RequisasComprasReporteLang,"descuento",Language)}`,
                            style: "header",
                          },
                          { text: `SUBTOTAL`, style: "header" },
                          { text: "TOTAL", style: "header" },
                        ],
                        ...productosMoneda,
                      ],
                    },
                    layout: "lightHorizontalLines",
                  },
          
                  {
                    margin: [0, 3, 5, 5],
                    table: {
                      widths: [45, 152, 32, 30, 32, 32, 32, 32, 76],
                      body: [
                        [
                          {
                            text: formatNumberDecimal(`${numberOfRows}`),
                            style: "headerr",
                            border: [false, true, false, false],
                            margin: [-20, 0, 0, 0]
                          },
                          {
                            text: ``,
                            style: "header",
                            border: [false, true, false, false],
                          },
                          {
                            text: formatNumberDecimal(`${numberOfProduct}`),
                            style: "headerr",
                            border: [false, true, false, false],
                          },
                          {
                            text: ``,
                            style: "header",
                            border: [false, true, false, false],
                          },
                          {
                            text: ``,
                            style: "header",
                            border: [false, true, false, false],
                          },
                          {
                            text: ``,
                            style: "header",
                            border: [false, true, false, false],
                          },
                          {
                            text: ``,
                            style: "header",
                            border: [false, true, false, false],
                          },
                          {
                            text: ``,
                            style: "header",
                            border: [false, true, false, false],
                          },
                          {
                            text: ``,
                            style: "header",
                            border: [false, true, false, false],
                          },
                        ],
                      ],
                    },
                    layout: {
                      hLineWidth: function (i) {
                        return 0.05; // Establecer grosor de línea horizontal
                      },
          
                      hLineColor: function (i) {
                        return "#aaa"; // Color de las líneas horizontales
                      },
                    },
                  },
          
                  {
                    margin: [0, 0, 5, 5, 5],
                    table: {
                      widths: [385, 50, 15, 60],
                      body: [
                        [
                          {
                            text: ``,
                            style: "textCentrado",
                            border: [false, false, false, false],
                            width: [340],
                          },
                          { text: "SubTotal", style: "textTotales" },
                          {
                            text: `${moneda}`,
                            border: [false, true, false, true],
                            style: "textTotales",
                          },
                          {
                            text: formatNumberDecimal(subtotalMoneda),
                            border: [false, true, true, true],
                            style: "textTotales",
                          },
                        ],
                        [
                          {
                            text: ``,
                            rowSpan: 2,
                            border: [false, false, false, false],
                            style: "textCentrado",
                            width: [340],
                          },
                          {
                            text: `${getLabel(RequisasComprasReporteLang,"descuento",Language)}`,
                            style: "textTotales",
                          },
                          {
                            text: `${moneda}`,
                            border: [false, true, false, true],
                            style: "textTotales",
                          },
                          {
                            text: formatNumberDecimal(descuentoMoneda),
                            style: "textTotales",
                            border: [false, true, true, true],
                          },
                        ],
                        [
                          { text: "", width: [320] },
                          {
                            text: `${getLabel(RequisasComprasReporteLang,"isv",Language )}`,
                            style: "textTotales",
                          },
                          {
                            text: `${moneda}`,
                            border: [false, true, false, true],
                            style: "textTotales",
                          },
                          {
                            text: formatNumberDecimal(impuestoMoneda + impuesto18Moneda),
                            style: "textTotales",
                            border: [false, true, true, true],
                          },
                        ],
                        [
                          {
                            text: "",
                            style: "textBody4",
                            border: [false, false, false, false],
                          },
                          { text: "Total", style: "textTotales" },
                          {
                            text: `${moneda}`,
                            border: [false, true, false, true],
                            style: "textTotales",
                          },
                          {
                            text: formatNumberDecimal(totalMoneda),
                            style: "textTotales",
                            border: [false, true, true, true],
                          },
                        ],
                      ],
                    },
                    layout: {
                      hLineWidth: function (i) {
                        return 0.05; // Establecer grosor de línea horizontal
                      },
                      vLineWidth: function (i) {
                        return 0.05; // Establecer grosor de línea vertical
                      },
                      hLineColor: function (i) {
                        return "#aaa"; // Color de las líneas horizontales
                      },
                      vLineColor: function (i) {
                        return "#aaa"; // Color de las líneas verticales
                      },
                    },
                  }
                );
              });

              let cantidadFirmas = 0

              const autorizoGerente = await getFirmaPersonal(Detalles[0]?.IdPersonalAutorizoGerente)
              // const autorizoFinanzas = await getFirmaPersonal(Detalles[0]?.IdPersonalAutorizoFinanzas);
              const autorizoPlantaM = await getFirmaPersonal(Detalles[0]?.IdPersonalAutorizoPlantManager);
              const imgBlanca = await getFirmaPersonal('111');
              const firmaGerentePDF = obtenerImagenPDF(autorizoGerente);
              const firmaPlantaPDF = obtenerImagenPDF(autorizoPlantaM);
              const firmaBlancaPDF = obtenerImagenPDF(imgBlanca);

              const necesitaFirmaGerente = Detalles.some(detalle => detalle.AutorizaGerente === true); //NECESITA
              if (necesitaFirmaGerente) cantidadFirmas++;
        
              const necesitaFinanzas = Detalles.some(detalle => detalle.Finanzas === true); //NECESITA
              if (necesitaFinanzas) cantidadFirmas++;


              // DISEÑO DEL COMENTARIO Y FIRMAS DEL REPORTE DE REQUISA COMPRAS
              docDefinitionRequisa.content.push(
                  {
                  columns: [
                      {
                      margin: [0, 45, 0, 0],
          
                      table: {
                          widths: ["*", 170, 40, 170, "*"],
                          headerRows: 2,
                          body: [
                          //COMENTARIO  
                          [
                            {
                              text: `Comentario: ${Encabezado.Comment || ""}`,
                              style: "titulo",
                              colSpan: 5,
                              margin: [0, 0, 0, 25],
                            },
                            {}, {}, {}, {},
                          ],
                          //FIRMAS
                          [
                             { text: "", margin: [0, 35, 0, 0] },

                            [
                              firmaGerentePDF || firmaBlancaPDF
                                ? {
                                    image: firmaGerentePDF || firmaBlancaPDF,
                                    width: 150,
                                    height: 100,
                                    margin: [0, 70, 0, -20],
                                  }
                                : {
                                    text: "",
                                    width: 150,
                                    height: 100,
                                    margin: [0, 70, 0, -20],
                                  },
                              necesitaFirmaGerente
                                ? {
                                    border: [false, true, false, false],
                                    text:
                                      `\n_______________________________________\n${getLabel(
                                        RequisasComprasReporteLang,
                                        "autorizadoPor",
                                        Language
                                      )}` +
                                      "\n" +
                                      UserNameAutorizoGerente,
                                    style: "firmas",
                                    width: [120],
                                  }
                                : {
                                    border: [false, true, false, false],
                                    text: "",
                                    style: "firmas",
                                    width: [120],
                                  },
                            ],

                            { text: "", margin: [0, 35, 0, 0] },

                            [
                              firmaPlantaPDF || firmaBlancaPDF
                                ? {
                                    image: firmaPlantaPDF || firmaBlancaPDF,
                                    width: 150,
                                    height: 100,
                                    margin: [0, 70, 0, -20],
                                  }
                                : {
                                    text: "",
                                    width: 150,
                                    height: 100,
                                    margin: [0, 70, 0, -20],
                                  },
                              {
                                border: [false, true, false, false],
                                text:
                                  `\n_______________________________________\n${getLabel(
                                    RequisasComprasReporteLang,
                                    "GerentePlanta",
                                    Language
                                  )}` +
                                  "\n" +
                                  UserNameautorizoPlantManager,
                                style: "firmas",
                                width: [120],
                              },
                            ],

                            { text: "" },
                          ],
                          // [
          
                          //     [
                          //       firmaGerentePDF || firmaBlancaPDF
                          //       ? {
                          //           image: firmaGerentePDF || firmaBlancaPDF,
                          //           width: 150,
                          //           height: 130,
                          //           margin: [0, 0, -50, -30],
                          //         }
                          //       : {
                          //           text: "",
                          //           width: 150,
                          //           height: 130,
                          //           margin: [0, 0, -50, -30],
                          //         },
                          //     // autorizoGerente
                          //     //     ? {
                          //     //     image: "data:image/png;base64," + autorizoGerente,
                          //     //     width: 150,
                          //     //     margin: [0, 0, -50, -30],
                          //     //     }
                          //     //     : {
                          //     //     image: "data:image/png;base64," + imgBlanca,
                          //     //     width: 150,
                          //     //     height: 130,
                          //     //     margin: [0, 0, -50, -30],
                          //     //     },
          
                          //         necesitaFirmaGerente ?
                          //     {
                          //         border: [false, true, false, false],
                          //         text: `\n  _______________________________________ \n${getLabel( RequisasComprasReporteLang, "autorizadoPor", Language  )}` + "\n" + UserNameAutorizoGerente,
                          //         style: "firmas",
                          //         width: [120],
                          //     } :                     {
                          //         border: [false, true, false, false],
                          //         text: '',
                          //         style: "firmas",
                          //         width: [120],
                          //     }
                          //     ],
          
                          //     { text: "" },
          
                          //     [
                          //     // autorizoFinanzas
                          //     //   ? {
                          //     //     image: "data:image/png;base64," + autorizoFinanzas,
                          //     //     width: 150,
                          //     //     margin: [0, 59, -50, -30],
                          //     //   }
                          //     //   : 
                          //         { text: "", margin: [-20, 115, -10, -10] },
                          //     // {
                          //     //   border: [false, true, false, false],
                          //     //   text:
                          //     //     `\n  _______________________________________ \n${getLabel(
                          //     //       RequisasComprasReporteLang,
                          //     //       "Finanzas",
                          //     //       Language
                          //     //     )}` +
                          //     //     "\n" +
                          //     //     UserNameAutorizoFinanzas,
                          //     //   style: "firmas",
                          //     //   width: [120],
                          //     // },
                          //     { text: "", margin: [-20, 115, -10, -10] },
          
                          //     ],
          
          
                          //     { text: "" },
          
                          //     [
                          //       firmaPlantaPDF || firmaBlancaPDF
                          //       ? {
                          //           image: firmaPlantaPDF || firmaBlancaPDF,
                          //           width: 150,
                          //           height: 130,
                          //           margin: [0, 0, -50, -30],
                          //         }
                          //       : {
                          //           text: "",
                          //           width: 150,
                          //           height: 130,
                          //           margin: [0, 0, -50, -30],
                          //         },
                          //     // autorizoPlantaM
                          //     //     ? {
                          //     //     image: "data:image/png;base64," + autorizoPlantaM,
                          //     //     width: 150,
                          //     //     height: 130,
                          //     //     margin: [0, 0, -50, -30],
                          //     //     }
                          //     //     : {
                          //     //     image: "data:image/png;base64," + imgBlanca,
                          //     //     width: 150,
                          //     //     height: 130,
                          //     //     margin: [0, 0, -50, -30],
                          //     //     },
                          //     {
                          //         border: [false, true, false, false],
                          //         text:
                          //         `\n  _______________________________________ \n${getLabel(
                          //             RequisasComprasReporteLang,
                          //             "GerentePlanta",
                          //             Language
                          //         )}` +
                          //         "\n" +
                          //         // listadoDetalles[0]?.UserNameAutorizoPlantManager || "",
                          //         UserNameautorizoPlantManager,
                          //         style: "firmas",
                          //         width: [120],
                          //     },
                          //     ],
          
                          // ],
                          ],
                      },
                      layout: {
                          defaultBorder: false,
                      },
                      },
                  ],
                  }
              )

              const docRequisa = pdfMake.createPdf(docDefinitionRequisa);
              await new Promise((resolve) => {
                docRequisa.getDataUrl((url) => {
                  pdfReq.push(url);
                  resolve();
                });
              });
          }

        }
      }

      setPdfRequisa(pdfReq)
    }

    setPdfOrden(pdfOr);     
  };

  const combinarPDFs = async (orden, requisa) => {
    const dataUnida = [...orden, ...requisa];

    if (!dataUnida || dataUnida.length === 0) {
      return;
    }

    try {
      const pdfDoc = await PDFDocument.create();

      for (const pdfBase64 of dataUnida) {
        const pdfBytes = await fetch(pdfBase64).then((res) =>
          res.arrayBuffer()
        );
        const pdfDocTemp = await PDFDocument.load(pdfBytes);
        const pages = await pdfDoc.copyPages(
          pdfDocTemp,
          pdfDocTemp.getPageIndices()
        );
        pages.forEach((page) => pdfDoc.addPage(page));
      }

      const mergedPdfBytes = await pdfDoc.save();

      // Crear un Blob y una URL temporal
      const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      setPdfUrlCombinado(blobUrl); // Seteamos la URL combinada del PDF
    } catch (error) {
      console.error("Error al combinar los PDFs:", error);
    }
  };

  useEffect(() => {
    if(pdfOrden && pdfRequisa){
      combinarPDFs(pdfOrden,pdfRequisa);
    }
  }, [pdfOrden, pdfRequisa]);

  useEffect(() => {
    if (showReporte) {
      obtenerInformacion();
    }
  }, [showReporte]);

  const onHideReporte = () => {
    setShowReporte(false);
    setLanguaje('es')
  };

  return (
    <Dialog
      visible={showReporte}
      onHide={onHideReporte}
      style={{ width: "63vw", height: "85vh" }}
    >
      <Loader loading={loading}/>
      <Toast ref={toast} />
      <div>
        {!loading && pdfUrlCombinado && (
          <iframe
            src={pdfUrlCombinado}
            style={{ width: "60vw", height: "75vh", border: "1px solid #ccc" }}
            id="foo"
            title="Reporte QR PDF"
          />
        )}
      </div>
    </Dialog>
  );
};

export default OrdenesComprasReporte1;
